import React from 'react';
import classNames from 'classnames';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import TimeUtil from 'time';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import RoleHelper from 'shared/lib/role';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';

import Tappable from 'react-tappable';

export default React.createClass({
  mixins: [PureRenderMixin],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    user: React.PropTypes.object.isRequired,
  },

  render() {
    const { rowIndex, item } = this.props;

    if (!item.get('displayDurationClock')) return null;

    return (
      <Tappable
        onTap={() =>
          CuesheetCellActions.startEditingItemCell(
            rowIndex,
            EditableCellTypes.ItemDuration,
          )
        }
      >
        {this._getDisplayNode()}
      </Tappable>
    );
  },

  _getDisplayNode() {
    const value = this._getDisplayValue();

    const { item, durationDisplayType } = this.props;

    let durationText = TimeUtil.getShorthandDuration(value);

    if (durationDisplayType === TimeDisplayTypes.clockTime) {
      durationText = TimeUtil.getShorthandFormattedPresetDuration(value);
    }
    if (durationDisplayType === TimeDisplayTypes.sixDigitTime) {
      durationText = TimeUtil.getFormattedDuration(value);
    }

    let classes = classNames('csr-cell csr-duration-cell', {
      'cs-preset-time-cell-over': value < 0,
    });

    let suppressedNode = null,
      itemRunTimeSuppressedNode = null;

    if (item.get('durationSuppressed') && this._hasAdmin()) {
      suppressedNode = this._getDurationSuppressedIconNode();
    }

    if (item.get('runTimeClockSuppressed') && this._hasAdmin()) {
      itemRunTimeSuppressedNode = this._getItemRunTimeSuppressedIconNode();
    }
    return (
      <span className={classes}>
        {durationText}
        <div className="cs-mute-duration">
          {suppressedNode} {itemRunTimeSuppressedNode}
        </div>
      </span>
    );
  },

  _getDurationSuppressedIconNode() {
    return <Icon name="duration_muted" ours />;
  },

  _getItemRunTimeSuppressedIconNode() {
    return <Icon name="hourglass_muted" ours />;
  },

  _getDisplayValue() {
    return this.props.item.get('durationInSeconds');
  },

  _hasAdmin() {
    const params = this.context.router.state.params;
    const { teamId, eventId } = params;

    return RoleHelper.hasEventAdminRole(this.context.user, teamId, eventId);
  },
});
